module.exports = __webpack_public_path__ + "img/ufa-bet-support.e031c4ff.png";